import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      determineActivePrice: 'cart/determineActivePrice'
    })
  }
};



// WEBPACK FOOTER //
// ./src/app/mixins/determineActivePrice.js